import React from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Input, Pagination } from 'semantic-ui-react';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    jumpContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginTop: '8px'
    },
    jumpLabel: {
        fontSize: '0.9em',
        color: '#666'
    },
    jumpInput: {
        width: '80px'
    }
};

export default class PaginationWithPageJump extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jumpValue: ''
        };
        this.handleJumpInputChange = this.handleJumpInputChange.bind(this);
        this.handleJumpSubmit = this.handleJumpSubmit.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }

    handleJumpInputChange(e, { value }) {
        if (value === '' || /^\d+$/.test(value)) {
            this.setState({ jumpValue: value });
        }
    }

    handleJumpSubmit() {
        const pageNum = parseInt(this.state.jumpValue, 10);
        if (isNaN(pageNum) || pageNum < 1 || pageNum > this.props.totalPages) {
            this.setState({ jumpValue: '' });
            return;
        }
        this.props.onPageChange(null, { activePage: pageNum });
        this.setState({ jumpValue: '' });
    }

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.handleJumpSubmit();
        }
    }

    render() {
        return (
            <div style={styles.container}>
                <Pagination
                    activePage={this.props.activePage}
                    totalPages={this.props.totalPages}
                    onPageChange={this.props.onPageChange}
                    ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                    firstItem={{ content: <Icon name="angle double left" />, icon: true }}
                    lastItem={{ content: <Icon name="angle double right" />, icon: true }}
                    prevItem={{ content: <Icon name="angle left" />, icon: true }}
                    nextItem={{ content: <Icon name="angle right" />, icon: true }}
                />
                {this.props.totalPages > 1 && (
                    <div style={styles.jumpContainer}>
                        <span style={styles.jumpLabel}>Idi na stranicu:</span>
                        <Input
                            type="text"
                            value={this.state.jumpValue}
                            onChange={this.handleJumpInputChange}
                            onKeyPress={this.handleKeyPress}
                            placeholder={'1 - ' + this.props.totalPages}
                            size="small"
                            style={styles.jumpInput}
                        />
                        <Button
                            size="small"
                            compact
                            basic
                            icon="arrow right"
                            onClick={this.handleJumpSubmit}
                            disabled={this.state.jumpValue === ''}
                        />
                    </div>
                )}
            </div>
        );
    }
}

PaginationWithPageJump.propTypes = {
    activePage: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired
};
